import { useEffect, useRef } from "react";

type DrawerSide = "left" | "right" | "top" | "bottom";

type DrawerProps = {
  open: boolean;
  onClose: () => void;
  side?: DrawerSide;
  children: React.ReactNode;
};

export default function Drawer({
  open,
  side = "bottom",
  children,
}: DrawerProps) {
  const isMountedRef = useRef(true);

  useEffect(() => {
    // if (open) document.body.style.overflow = "hidden";
    // else document.body.style.overflow = "";

    return () => {
      // Only restore overflow if component is still mounted
      if (isMountedRef.current) {
        // document.body.style.overflow = "";
      }
    };
  }, [open]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return (
    <>
      {/* Drawer */}
      <aside
        className={`drawer drawer-${side} ${open ? "open" : ""}`}
        style={
          side === "top" || side === "bottom"
            ? { height: '450px' }
            : { width: '2880x' }
        }
      >
        {children}
      </aside>
    </>
  );
}
